module.exports = __webpack_public_path__ + "img/device.08bd10c.svg";